import { useEffect, useState } from 'react'
import Modal from '../../../../../common/components/molecule/Modal/Modal'
import TextInput from '../../../../../common/components/atom/TextInput/TextInput'
import ButtonV2 from '../../../../../common/components/atom/ButtonV2/Button'
import { useToast } from '../../../../../common/providers/ToastProvider/useToast'
import { useCreateLuminaire } from '../../../../../features/luminaire/hooks/useLuminaires'

interface AddZhagaNodeDialogProps {
  open: boolean
  onClose: () => void
}

export default function AddZhagaNodeDialog({ open, onClose }: AddZhagaNodeDialogProps) {
  const [devEui, setDevEui] = useState('')
  const [poleNumber, setPoleNumber] = useState('')
  const [phaseNumber, setPhaseNumber] = useState('')
  const [name, setName] = useState('')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const toast = useToast()
  const createLuminaire = useCreateLuminaire()

  useEffect(() => {
    if (open) {
      setDevEui('')
      setPoleNumber('')
      setPhaseNumber('')
      setName('')
      setErrorMessage(null)
    }
  }, [open])

  const isSubmitDisabled =
    devEui.trim() === '' ||
    poleNumber.trim() === '' ||
    phaseNumber.trim() === ''

  const handleSubmit = () => {
    if (isSubmitDisabled) return
    setErrorMessage(null)
    createLuminaire.mutate({
      luminaire: {
        lum_name: name.trim() || 'Luminaire-' + devEui.slice(0, 8),
        lum_dev_eui: devEui.trim(),
        lum_pole_number: poleNumber.trim(),
        lum_phase_number: phaseNumber.trim(),
        lum_status: 'active',
      },
      callbackFunc: ({ error }) => {
        if (error) {
          const status = error?.response?.status
          const backendMsg = error?.response?.data?.message
          const msg =
            backendMsg ??
            (status === 409 || status === 400
              ? 'devEUI déjà enregistré ou invalide'
              : "Erreur lors de l'ajout du luminaire")
          setErrorMessage(msg)
          toast.error(msg)
        } else {
          toast.success('Luminaire ajouté')
          onClose()
        }
      },
    })
  }

  return (
    <Modal isOpen={open} handleClose={onClose}>
      <h2>Ajouter un nœud Zhaga</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
        <TextInput
          label="devEUI *"
          value={devEui}
          onChange={(e) => {
            setDevEui(e.target.value)
            if (errorMessage) setErrorMessage(null)
          }}
        />
        <TextInput
          label="Numéro de poteau *"
          value={poleNumber}
          onChange={(e) => setPoleNumber(e.target.value)}
        />
        <TextInput
          label="Numéro de phase *"
          value={phaseNumber}
          onChange={(e) => setPhaseNumber(e.target.value)}
        />
        <TextInput
          label="Nom (optionnel)"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        {errorMessage && (
          <div
            role="alert"
            style={{
              background: '#fdecea',
              border: '1px solid #f5c2c0',
              color: '#b00020',
              padding: '0.5rem 0.75rem',
              borderRadius: 4,
              fontSize: 13,
            }}
          >
            {errorMessage}
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
        <ButtonV2
          onClick={onClose}
          variant="outlined"
          color="secondary"
          size="medium"
        >
          Annuler
        </ButtonV2>
        <ButtonV2
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          size="medium"
          disabled={isSubmitDisabled}
        >
          Enregistrer
        </ButtonV2>
      </div>
    </Modal>
  )
}
